import { render, staticRenderFns } from "./TreeClassificator.vue?vue&type=template&id=00bcbd1b&scoped=true"
import script from "./TreeClassificator.vue?vue&type=script&lang=js"
export * from "./TreeClassificator.vue?vue&type=script&lang=js"
import style0 from "./TreeClassificator.vue?vue&type=style&index=0&id=00bcbd1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcbd1b",
  null
  
)

export default component.exports